<template>
  <div class="schedule-tab">
    <div class="list-type clearfix">
      <el-row :gutter="20">
        <el-col :span="10">
          <div class="data-day">
            <el-button class="egl-btn-white-gray-border" @click="dayChange(0)">{{ $locale("global.today") }}</el-button>
            <!-- <el-button type="text" @click="dayChange(-1)"><i class="el-icon-arrow-left"></i></el-button>
            <span>{{ targetDayText }}</span>
            <el-button type="text" @click="dayChange(1)"><i class="el-icon-arrow-right"></i></el-button> -->
          </div>

          <div class="schedule-date-picker">
            <!-- <el-date-picker
              :clearable="false"
              value-format="yyyy-MM-dd"
              v-model="date"
              @change="updateTargetDay_fn"
            ></el-date-picker> -->
            <CommDatePicker
              v-model="date"
              :value.sync="date"
              @change="updateTargetDay_fn"
              valueFormat="yyyy-MM-dd"
              :showWeekly="true"
              :isForSchedule="true"
            />
          </div>
        </el-col>
        <el-col :span="14" class="ta-r">
          <el-button
            :class="btn.value == actBtn ? 'egl-btn-white-gray-border act' : 'egl-btn-white-gray-border'"
            v-for="btn in btnList"
            :key="btn.value"
            @click="$emit('handleFn', { type: 'list', value: btn.value })"
            >{{ btn.label }}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { formatDay } from "@/assets/js/schedule.js";
import "@/assets/style/schedule.less";
import CommDatePicker from "@/components/common/CommDatePicker";

export default {
  name: "ScheduleTab",
  data() {
    return {
      targetDayText: "",
      btnList: [
        {
          label: this.$locale("calendar.day"),
          value: "DAYS"
        },
        // {
        //   label: this.$locale("calendar.week"),
        //   value: "WEEKLY"
        // }
      ],
      today: "",
      date: this.$moment().format("YYYY-MM-DD")
    };
  },
  methods: {
    dayChange(num) {
      let newDay = this.targetDay;

      if (num == 0) {
        newDay = this.today;
      } else {
        newDay = this.$moment(newDay)
          .add(num, "days")
          .format("YYYY-MM-DD");
      }

      this.$emit("handleFn", { type: "date", value: newDay });
    },
    updateTargetDay_fn(date) {
      console.log(date);
      // this.$emit("update:targetDay", this.date);
      this.$emit("handleFn", { type: "date", value: date });
    }
  },
  mounted() {
    const today = this.$moment().format("YYYY-MM-DD");
    this.today = today;
  },
  props: {
    targetDay: {
      type: String,
      default: ""
    },
    actBtn: {
      type: String,
      default: "WEEKLY"
    }
  },
  watch: {
    targetDay() {
      this.targetDayText = formatDay(this.targetDay);
      this.date = this.targetDay
    }
  },
  components: {
    CommDatePicker
  }
};
</script>
